import React, { memo } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, WrapListContainer } from '@redlink/components/atoms';
import { StatusItem } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';

export const OrderStatusList = memo(({ selectedId, onChange, style }) => {
  const { styles } = useStyle();
  const { dictionary } = useLocale();

  const data = [
    { id: null, value: dictionary.all },
    { id: 'new', value: dictionary.orderStatusNew },
    { id: 'packaging', value: dictionary.orderStatusPackaging },
    { id: 'delivery', value: dictionary.orderStatusDelivery },
    { id: 'done', value: dictionary.orderStatusDone },
    { id: 'cancel', value: dictionary.orderStatusCancel },
  ];

  return (
    <WrapListContainer {...{ style }}>
      {data.map((item, index) => {
        const isFocused = selectedId === item.id;
        return (
          <>
            <StatusItem
              style={styles.itemContainer}
              {...{ item, isFocused }}
              onPress={() => onChange && onChange(item.id, index)}
            />
            <Space size={8} />
          </>
        );
      })}
    </WrapListContainer>
  );
});

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  itemContainer: {
    marginVertical: 4,
  },
}));
